import { render, staticRenderFns } from "./payment_attached_locations.vue?vue&type=template&id=bb0ebece&scoped=true&"
import script from "./payment_attached_locations.vue?vue&type=script&lang=js&"
export * from "./payment_attached_locations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0ebece",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb0ebece')) {
      api.createRecord('bb0ebece', component.options)
    } else {
      api.reload('bb0ebece', component.options)
    }
    module.hot.accept("./payment_attached_locations.vue?vue&type=template&id=bb0ebece&scoped=true&", function () {
      api.rerender('bb0ebece', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/payments/item/pay_tabs/payment_attached_locations.vue"
export default component.exports